import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { createRenovationsFields } from './renovations-fields';

export const getRenovationsData = (home: NestedHome) => {
  const context = { home };
  const renovationsFields = createRenovationsFields(context);
  
  return new HomeDataBuilder()
    .withFields(renovationsFields)
    .build({ home });
};
